import { render, staticRenderFns } from "./TouchpointArrival.vue?vue&type=template&id=e20ed900&scoped=true&"
import script from "./TouchpointArrival.vue?vue&type=script&lang=js&"
export * from "./TouchpointArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ed900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20ed900')) {
      api.createRecord('e20ed900', component.options)
    } else {
      api.reload('e20ed900', component.options)
    }
    module.hot.accept("./TouchpointArrival.vue?vue&type=template&id=e20ed900&scoped=true&", function () {
      api.rerender('e20ed900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/Touchpoint/TouchpointArrival.vue"
export default component.exports